module.exports = __webpack_public_path__ + "pediatrician___24j7c.svg";